/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Footer_Link_TermsInputs */

const en_landing_footer_link_terms = /** @type {(inputs: Landing_Footer_Link_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terms of use`)
};

/**
* | output |
* | --- |
* | "Terms of use" |
*
* @param {Landing_Footer_Link_TermsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const landing_footer_link_terms = /** @type {((inputs?: Landing_Footer_Link_TermsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Footer_Link_TermsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_landing_footer_link_terms(inputs)
});